import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputCrmAnhangAttachementModify<T extends EMode = EMode.entity> {
  /** Alias: code */
  code?: number;
  /** Alias: name */
  name?: string;

  __typename?: string;
}

const fields: FieldDefinitions<InputCrmAnhangAttachementModify> = {
  code: {
    alias: 'code',
  },
  name: {
    alias: 'name',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputCrmAnhangAttachementModifyEntityDefinition: EntitiyDefinition<InputCrmAnhangAttachementModify> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputCrmAnhangAttachementModify',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
